import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Motion classes gate the hidden "before" states of reveals. The prerender
// strips <html class>, so crawlers and no-JS visitors get visible content.
// navigator.webdriver: the prerender crawler snapshots the settled page, so it
// gets no motion at all.
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches && !navigator.webdriver) {
  document.documentElement.classList.add("motion");
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
